"use client"
import { useState } from "react"
import { useRouter } from "next/navigation"

type MobileFooterItem = {
    title: string
    url?: string
}

type MobileFooterSectionProps = {
    title: string
    items: MobileFooterItem[]
}

const MobileFooterSection = ({ title, items }: MobileFooterSectionProps) => {
    const [show, setShow] = useState(false)
    const router = useRouter()

    const handleItemClick = (item: MobileFooterItem) => {
        if (!item.url) return

        if (/^https?:\/\//i.test(item.url)) {
            window.open(item.url, "_blank", "noopener,noreferrer")
            return
        }

        router.push(item.url)
    }

    return <div>
        <div className='flex justify-between items-center h-[17px] text-[12px] font-regular leading-none ' onClick={() => setShow(!show)}>
            <div>{title}</div>

            <svg
                viewBox="0 0 12.004 6.17792"
                xmlns="http://www.w3.org/2000/svg"
                width="12.004028"
                height="6.177917"
                fill="none"
                className={`transition-transform duration-200 ${show ? "rotate-180" : "rotate-0"}`}
            >
                <path id="Vector 24" d="M0 0L5 5.73913L0 11" stroke="rgb(119,119,119)" strokeLinecap="round" strokeWidth="1.000000" transform="matrix(-4.37114e-08,1,-1,-4.37114e-08,11.502,0.502014)" />
            </svg>

        </div>
        <div className={`w-full px-[40px] flex flex-col gap-[12px] overflow-hidden transition-all duration-200 ${show ? "mt-[16px] max-h-[240px] opacity-100" : "mt-0 max-h-0 opacity-0"}`}>
            {items.map((item) => {
                return (
                    <div
                        key={item.title}
                        className={`text-[12px] font-light leading-none text-[rgba(51,51,51,1)] ${item.url ? "cursor-pointer" : ""}`}
                        onClick={() => handleItemClick(item)}
                    >
                        {item.title}
                    </div>
                )
            })}
        </div>
        <div className="h-px bg-[rgba(241,241,241,1)] mt-[11px] w-full" />
    </div>
}

export const MobileFooter = () => {
    const product = [
        {
            title: "全球SD-WAN网络加速服务",
            url: "/sdwan",
        },
        {
            title: "企业组网/私有化部署",
            url: "/private",
        },
        {
            title: "全球直播专线/TK直播养号",
            url: "/tiktok",
        },
        {
            title: "全球办公网络与应用加速",
            url: "/saas",
        },
        // {
        //   title: "光年游戏加速器",
        // },
    ];

    const help = [
        {
            title: "联系客服",
        },
        {
            title: "我要建议",
        },
        {
            title: "控制台",
        },
        {
            title: "常见问题",
        },
    ];
    const about = [
        {
            title: "关于我们",
            url: "/about",
        },
        {
            title: "加入我们",
        },
        {
            title: "商务合作",
            url: "https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b",
        },
    ];

    return <div className="p-[20px] bg-white flex flex-col gap-[12px]">
        <MobileFooterSection title="产品和服务" items={product} />
        <MobileFooterSection title="帮助与支持" items={help} />
        <MobileFooterSection title="关于我们" items={about} />
        <img src="/imgs/logo-footer.png" className="w-[80px] h-[18px] mt-[12px]" />
        <div className="mt-[7px] text-[10px] font-light leading-4 text-[rgba(51,51,51,1)]">
            光年无界出海网络服务，为出海企业提供了一个可快速落地的全球跨境网络一站式服务。自研的软硬件系统、覆盖全球的网络资源、专业的运维团队，依托三大运营商的网络专线资源，腾讯云深度合作赋能，为全球跨境短视频直播、全球跨境电商企业、商家、MCN机构、游戏出海平台等提供稳定、高速、安全的跨境网络服务。
        </div>
        <div className="h-px bg-[rgba(241,241,241,1)] mt-[11px] w-full" />
        <div className="text-[#333] text-[8px] font-light leading-none flex items-center ">
            杭州光年无界科技有限公司&nbsp;|&nbsp;
            <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="flex items-center justify-center">
                    <img
                        src="/imgs/gh.png"
                        alt="豫公网安备"
                        className="mr-[5px] h-[12px] w-[12px]"
                    />
                    浙ICP备2025193092号-2
                </div>
            </a>
        </div>
        <div className="text-[#333] text-[8px] font-light leading-none flex items-center ">增值电信业务经营许可 B1-20253714</div>
    </div>
}